module.exports = __webpack_public_path__ + "static/media/1_en.56f819e0.png";